import React from 'react';
import { connect } from 'react-redux';

import mea from '../../../services/mea';
import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import MeaCarouselComponent from './MeaCarouselComponent';
import MobileMeaOfferSelection from './MobileMeaOfferSelection';
import DesktopMeaOfferSelection from './DesktopMeaOfferSelection';
import LinkButtonComponent from '../../button/LinkButtonComponent';

import './HomePage.scss';

export class HomePage extends React.Component {
    componentDidMount() {
        this.props.fetchMeasIfNeeded(mea.constants.CAROUSEL_MEA_TYPE);
        this.props.fetchMeasIfNeeded(mea.constants.ONLINE_OFFER);
        this.props.fetchMeasIfNeeded(mea.constants.OFFLINE_OFFER);
        this.props.fetchMeasIfNeeded(mea.constants.EBON_OFFER);
        this.props.fetchMeasIfNeeded(mea.constants.RESPONSIBLE_OFFER);
    }

    render() {
        const { i18nHome } = this.props;

        return (
            <main role="main" className="conteneur" id="p-accueil">
                <HeadComponent
                    title={i18nHome.TITLE}
                    description={i18nHome.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.HOME_PATH}`}
                />

                <MeaCarouselComponent />

                <div>
                    <h2 className="conteneur-mobile">{i18nHome.CASHBACK_OFFER}</h2>
                    <div className="linkWrapper">
                        <LinkButtonComponent
                            to={PATH.CASHBACK_ONLINE_MOST_POPULAR_PATH}
                            title={i18nHome.ONLINE_CASHBACK}
                            color="main"
                            text={i18nHome.ONLINE_CASHBACK}
                        />
                        <LinkButtonComponent
                            to={PATH.CASHBACK_OFFLINE_MOST_POPULAR_PATH}
                            title={i18nHome.OFFLINE_CASHBACK}
                            color="main"
                            text={i18nHome.OFFLINE_CASHBACK}
                        />
                        <LinkButtonComponent
                            to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                            title={i18nHome.EBON_CASHBACK}
                            color="main"
                            text={i18nHome.EBON_CASHBACK}
                        />
                    </div>
                </div>

                <DesktopMeaOfferSelection isOnline />
                <MobileMeaOfferSelection isOnline />

                <DesktopMeaOfferSelection isEbon />
                <MobileMeaOfferSelection isEbon />

                <DesktopMeaOfferSelection isOffline />
                <MobileMeaOfferSelection isOffline />

                <DesktopMeaOfferSelection isResponsibleOffer />
                <MobileMeaOfferSelection isResponsibleOffer />
            </main>
        );
    }
}

const mapStateToProps = state => ({
    i18nHome: state.i18n.page.HOME
});

const mapDispatchToProps = {
    fetchMeasIfNeeded: mea.actions.fetchMeasIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HomePage),
    PrimaryTemplate,
    {
        hideBreadcrumb: true
    }
);



// WEBPACK FOOTER //
// ./src/components/pages/home/HomePage.js